import { Alert, Container, Snackbar, styled, Typography } from '@mui/material';
import { useState } from 'react';
import JobsTable from '../../components/JobTracker/JobsTable';

const TextWrapper = styled('div')({
  gridColumn: '1/5',
});

function JobTracker() {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState<'success' | 'error'>('success');

  const handleSnackbarClose = (_event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };

  const showSnackbar = (message: string, severity: 'success' | 'error') => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  return (
    <>
      <Container sx={{ marginBottom: 10, display: 'flex', flexDirection: 'column', gap: 4 }}>
        <TextWrapper>
          <Typography
            variant='h5'
            sx={{
              fontWeight: 'bold',
            }}
          >
            Job tracker
          </Typography>
          <Typography
            variant='body2'
            sx={{
              color: 'text.secondary',
              marginTop: 2,
            }}
          >
            Track the latest run of each background job and start a job manually. A job cannot be started while it is
            already queued or in progress.
          </Typography>
        </TextWrapper>
        <JobsTable snackbarData={showSnackbar} />
      </Container>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
}

export default JobTracker;
